/** Egen inngang for Toppkontroll (/toppkontroll/?project=…). Vieweren er separat; funnene vises der senere. */
import './styles.css';
import './workspace.css';
import { fetchProject } from './api';
import { loadConfig } from './config';
import { renderFatal, renderLoading } from './ui';
import { applyTheme } from './ui/theme';
import { startTopControl } from './topcontrol/workspace';

applyTheme();
const cfg = loadConfig();
const root = document.getElementById('app')!;

async function start(): Promise<void> {
  renderLoading(root, `Henter prosjekt «${cfg.projectId}» …`);
  let project;
  try {
    project = await fetchProject(cfg.metadataBase, cfg.apiBase, cfg.projectId);
  } catch {
    // Kontrollen virker uten serverprosjekt: bilder legges til lokalt
    project = { projectId: cfg.projectId, projectName: cfg.projectId, raw: {}, pointclouds: [], invalid: [] };
  }
  await startTopControl(root, { project, cfg });
}
void start().catch((e) => renderFatal(root, 'Kunne ikke starte Toppkontroll', (e as Error).message, location.href, () => void start()));
